import { Revision } from 'types'
import { EditorView } from 'prosemirror-view'
import { ReplaceSelectionButton } from 'components/AIRevision/ReplaceSelectionButton'
import { AddBelowButton } from 'components/AIRevision/AddBelowButton'
import { RevisionPrompt } from 'components/AIRevision/RevisionPrompt'
import Styles from './CompleteActions.module.scss'
import cx from 'classnames'
import { useFocusWithin } from '@react-aria/interactions'
import { useState } from 'react'
import { RetryIconButton } from 'components/AIRevision/RetryIconButton'
import { CopyIconButton } from 'components/AIRevision/CopyIconButton'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export interface Props {
  revision: Revision
  view: EditorView
  articleId: string
  layerId: string
  customPrompt: string
  onPromptChange: (prompt: string) => any
}

export const CompleteActions = ({ revision, view, articleId, layerId, customPrompt, onPromptChange }: Props) => {
  const hasPrompt = customPrompt.trim().length > 0
  const [isRevisionPromptFocused, setIsRevisionPromptFocused] = useState(false)
  const { isMobile } = useResponsiveDesign()

  const { focusWithinProps } = useFocusWithin({
    onFocusWithinChange: (isFocusWithin) => setIsRevisionPromptFocused(isFocusWithin),
  })

  const isActive = hasPrompt && isRevisionPromptFocused

  return (
    <>
      <div className={cx(Styles.promptContainer, { [Styles.promptActive]: isActive })} {...focusWithinProps}>
        <RevisionPrompt
          articleId={articleId}
          layerId={layerId}
          isActive={isRevisionPromptFocused}
          onChange={onPromptChange}
          previousRevisionId={revision.id}
          customPrompt={customPrompt}
          menuOffsetOptions={{ mainAxis: 16, crossAxis: -42 }}
          submitIconSize={isMobile ? 'lg' : 'sm'}
          inputSize="md"
        />
      </div>
      <div className={cx(Styles.buttonContainer, { [Styles.promptActive]: isActive })}>
        <ResponsiveDesign.Desktop>
          <CopyIconButton revision={revision} view={view} />
          <RetryIconButton revision={revision} view={view} />
          <AddBelowButton revision={revision} />
          <ReplaceSelectionButton revision={revision} />
        </ResponsiveDesign.Desktop>
        <ResponsiveDesign.Mobile>
          <ReplaceSelectionButton revision={revision} />
          <AddBelowButton revision={revision} />
        </ResponsiveDesign.Mobile>
      </div>
    </>
  )
}
